import { render, staticRenderFns } from "./IndexContactInfo.vue?vue&type=template&id=667c128c&scoped=true&"
import script from "./IndexContactInfo.vue?vue&type=script&lang=js&"
export * from "./IndexContactInfo.vue?vue&type=script&lang=js&"
import style0 from "./IndexContactInfo.vue?vue&type=style&index=0&id=667c128c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667c128c",
  null
  
)

export default component.exports